import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../shared.module';

@Component({
  standalone: true,
  selector: 'icu-palette-button',
  templateUrl: 'palette-button.component.html',
  imports: [SharedModule]
})
export class PaletteButtonComponent {
  @Input() color?: string;

  @Output() clicked = new EventEmitter<void>();

  onClicked(): void {
    this.clicked.emit();
  }
}
